module.exports = __webpack_public_path__ + "static/img/he12.44ff98a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/he12.png
// module id = AurM
// module chunks = 1